export const getPaymentStatusText = (navigatedFrom, paymentDetailStatus) => {
  if (navigatedFrom == "paymentDetails") {
    if (paymentDetailStatus == "paid") return "Paid";
    if (paymentDetailStatus == "pending") return "Pending";
    if (paymentDetailStatus == "failed") return "Failed";
  }
  return "-";
};

export const getStatusColor = (status) => {
  if (!status) return "var(--color-primitives-primary)";

  if (status === "paid") return "var(--color-text-success)";
  if (status === "pending") return "var(--color-text-warning)";
  if (status === "failed") return "var(--color-text-danger)";

  return "var(--color-primitives-primary)";
};

export const getPaymentChipColor = (status) => {
  if (status === "failed") {
    return "error";
  }
  if (status === "pending") {
    return "warning";
  }
  if (status === "un-paid") {
    return "warning";
  }
  return "success";
};

export const getPaymentChipLabel = (status) => {
  if (status === "failed") {
    return "Failed";
  }
  if (status === "pending") {
    return "Pending";
  }
  if (status === "un-paid") {
    return "Pending";
  }
  return "Successful";
};

export const getPaymentChipIconColor = (status) => {
  if (status === "success") {
    return "color-chip-icon-success";
  }
  if (status === "pending" || status === "un-paid") {
    return "color-chip-icon-warning";
  }
  return "color-chip-icon-error";
};

export const getDaysUntilExpiry = (expiry) => {
  if (!expiry || typeof expiry !== "string" || !expiry.includes("-")) {
    return { diffDays: null, expiryDate: null };
  }

  const [month, year] = expiry.split("-").map(Number);

  if (!month || !year) {
    return { diffDays: null, expiryDate: null };
  }

  const expiryDate = new Date(year, month, 0);

  if (Number.isNaN(expiryDate.getTime())) {
    return { diffDays: null, expiryDate: null };
  }

  const today = new Date();
  const diffTime = expiryDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return { diffDays, expiryDate };
};

export function CardExpiryWarning({ expiry, warningDays }) {
  const result = getDaysUntilExpiry(expiry);

  if (!result || result.diffDays === null || !result.expiryDate) {
    return null;
  }

  const { diffDays, expiryDate } = result;

  if (diffDays <= warningDays) {
    if (diffDays < 0)
      return (
        <p className="heading-h5-medium color-text-danger">
          Expired on{" "}
          {expiryDate.toLocaleDateString("en-US", {
            month: "2-digit",
            year: "2-digit",
          })}
        </p>
      );
    if (diffDays === 0) return <p className="heading-h5-medium color-text-warning-secondary">Expires today</p>;
    return (
      <p className="heading-h5-medium color-text-warning-secondary">
        Expires in {diffDays} days on{" "}
        {expiryDate.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })}
      </p>
    );
  }

  return (
    <p className="heading-h5-medium color-text-body-primary">
      Exp. date{" "}
      {expiryDate.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "2-digit",
      })}
    </p>
  );
}
